export const dateLocaleFormats = {
  de: 'DD.MM.Y',
  en: 'MM-DD-Y',
};

export const dateWithTimeLocaleFormats = {
  de: 'DD.MM.Y HH:mm',
  en: 'MM-DD-Y HH:mm A',
};

export const months = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const imageFormats = ['.png', '.jpg', '.jpeg', '.gif'];

export const measures = {
  m2: {
    locale: 'm',
    areaLocale: 'm²',
    key: 'm2',
    ratio: 0.092903,
  },
  f2: {
    locale: 'ft',
    areaLocale: 'ft²',
    key: 'f2',
    ratio: 10.764,
  },
};

export interface Currency {
  symbol: string;
  side: 'left' | 'right';
}

export const currencies: { [code: string]: Currency } = {
  EUR: {
    symbol: '€',
    side: 'right',
  },
  USD: {
    symbol: '$',
    side: 'left',
  },
  PHP: {
    symbol: '₱',
    side: 'right',
  },
  HUF: {
    symbol: 'Ft',
    side: 'right',
  },
  CZK: {
    symbol: 'Kč',
    side: 'right',
  },
  RON: {
    symbol: 'lei',
    side: 'right',
  },
  IDR: {
    symbol: 'Rp',
    side: 'right',
  },
  INR: {
    symbol: '₹',
    side: 'right',
  },
  RUB: {
    symbol: '₽',
    side: 'right',
  },
  HRK: {
    symbol: 'kn',
    side: 'right',
  },
  JPY: {
    symbol: '¥',
    side: 'right',
  },
  THB: {
    symbol: '฿',
    side: 'right',
  },
  CHF: {
    symbol: 'CHF',
    side: 'right',
  },
  PLN: {
    symbol: 'zł',
    side: 'right',
  },
  BGN: {
    symbol: 'лв',
    side: 'right',
  },
  TRY: {
    symbol: '₺',
    side: 'right',
  },
  CNY: {
    symbol: '¥',
    side: 'right',
  },
  ZAR: {
    symbol: 'R',
    side: 'right',
  },
  ILS: {
    symbol: '₪',
    side: 'right',
  },
  GBP: {
    symbol: '£',
    side: 'right',
  },
  KRW: {
    symbol: '₩',
    side: 'right',
  },
  MYR: {
    symbol: 'RM',
    side: 'right',
  },
  DKK: {
    symbol: 'DKK',
    side: 'right',
  },
  SEK: {
    symbol: 'SEK',
    side: 'right',
  },
  ISK: {
    symbol: 'ISK',
    side: 'right',
  },
  NOK: {
    symbol: 'NOK',
    side: 'right',
  },
  AUD: {
    symbol: 'AUD',
    side: 'right',
  },
  BRL: {
    symbol: 'R$',
    side: 'left',
  },
  CAD: {
    symbol: 'C$',
    side: 'left',
  },
  HKD: {
    symbol: 'HKD',
    side: 'right',
  },
  MXN: {
    symbol: 'Mex$',
    side: 'left',
  },
  NZD: {
    symbol: 'NZ$',
    side: 'left',
  },
  SGD: {
    symbol: 'S$',
    side: 'left',
  },
};
